import { render, staticRenderFns } from "./view-icon-upload.vue?vue&type=template&id=88c1420a&scoped=true&"
import script from "./view-icon-upload.vue?vue&type=script&lang=js&"
export * from "./view-icon-upload.vue?vue&type=script&lang=js&"
import style0 from "./view-icon-upload.vue?vue&type=style&index=0&id=88c1420a&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c1420a",
  null
  
)

export default component.exports